import React, { useState, useEffect } from "react";
import { observer } from 'mobx-react';
import { Grid, Box, Typography, Paper, Button, List, ListItem, ListItemIcon, ListItemText, Tooltip, Collapse, Alert } from "@mui/material";
import Header from "../shared/header";
import Footer from "../shared/footer";
import styles from './membership.module.scss'
import ChargeModal from "../wallet/charge-modal";
import MembershipUiStore from "./membership-ui-store";
import { InfoCircle, TickCircle } from "iconsax-react";
import { icons, memberships } from "../../constants/general";
import RoundButton from "../shared/components/round-btn";

const uiStore = new MembershipUiStore();

const Membership = observer(({ history, context }) => {
    const [showOrderSummary, setShowOrderSummary] = useState(false);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [showSuccess, setShowSucess] = useState(false);
    const [selectedMembership, setSelectedMembership] = useState({ id: '1' });
    const { membership: userMembership } = uiStore;
    const [loading, setLoading] = useState(false);

    const getMembershipIcon = (membership, summary = false) => {
        if (!membership)
            return <></>

        const Component = icons[membership];
        return summary ?
            <Component
                size="32"
                color="#ffb300"
                variant="Bulk"
            />
            :
            <Component
                size="24"
                variant="Bulk"
                style={{ float: 'left', margin: '5px 10px 0 0' }}
            />
    };

    const selectMembership = (id) => {
        const membership = memberships.find(i => i._id === id); 
        setSelectedMembership(membership);
        setShowOrderSummary(true);
    };

    useEffect(() => {
        async function fetchData() {
            uiStore.initliazeContext(context);
            await uiStore.getMembership();
        }

        fetchData()
    }, [context]);

    const onSuccess = () => {
        setShowSucess(true);
        setShowOrderSummary(false);
    }

    const updateMembership = async () => {
        setLoading(true);
        await uiStore.updateMembership(selectedMembership._id);
        await uiStore.getMembership();
        setLoading(false);
        setShowSucess(true);
        setShowOrderSummary(false);
    };

    return (
        <>
            <Header></Header>
            <Grid className='content' container>
                <Box className={styles.wrapper}>
                    <Collapse in={!showOrderSummary}>

                        <Box sx={{ mt: 2 }}>
                            <Typography variant="h6" color='#242333' fontWeight={700}>Membership</Typography>
                        </Box>
                        {showSuccess &&
                            <Alert severity='success' sx={{ mt: 2 }}>
                                <b>Successful</b>: Membership has been updated
                            </Alert>
                        }
                        <Grid container sx={{ mt: 2, justifyContent: 'center' }} spacing={2}>
                            {memberships.map(membership =>
                                <Grid key={membership._id} item lg={4} md={6} sm={12} xs={12}>
                                    <Paper variant="round" sx={{ p: 3, width: '80%' }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography variant="h6" fontWeight={600}>
                                                {getMembershipIcon(membership.name)}
                                                {membership.name}
                                            </Typography>
                                            <Tooltip title={membership.info}>
                                                <InfoCircle size="32" variant="Bulk" style={{ transform: 'rotate(-180deg)' }} />
                                            </Tooltip>
                                        </Box>
                                        <Typography color='#888' fontSize={14}>{membership.title}</Typography>
                                        <Typography fontWeight={500} sx={{ m: "16px 0" }}>{membership.price === 0.0 ? 'Free' : '$' + membership.price} / lifetime</Typography>
                                        <Button
                                            color="secondary"
                                            disabled={userMembership === membership._id}
                                            onClick={() => selectMembership(membership._id)}
                                            variant="contained"
                                            sx={{ height: 'fit-content' }}
                                        >
                                            {userMembership === membership._id ?
                                                'Current'
                                                :
                                                'Select'
                                            }
                                        </Button>

                                        <Typography fontWeight={500} sx={{ m: "16px 0" }} fontSize={14}>{membership.name} membership includes</Typography>
                                        <List sx={{ mt: 2 }}>
                                            {membership.features.map(item =>
                                                <ListItem key={item} disablePadding>
                                                    <ListItemIcon sx={{ minWidth: 0, mr: 1 }}>
                                                        <TickCircle
                                                            size="24"
                                                            variant="Bulk"
                                                            color='#02B28E'
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText primaryTypographyProps={{ fontSize: 14 }} primary={item} />
                                                </ListItem>
                                            )}
                                        </List>
                                    </Paper>
                                </Grid>
                            )}
                        </Grid>
                    </Collapse>

                    <Collapse in={showOrderSummary}>
                        <Box sx={{ mt: 2 }}>
                            <Typography variant="h6" color='#242333' fontWeight={700}>Order Summary</Typography>
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: 'center', mt: 2 }}>
                            <Paper variant="round" sx={{ p: 4, width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                                <Box sx={{ display: 'flex' }}>
                                    <Box className={styles.walletIcon}>
                                        {getMembershipIcon(selectedMembership.name, true)}
                                    </Box>
                                    <Box sx={{ ml: 2, mt: 1 }}>
                                        <Typography fontWeight={600}>{selectedMembership.name}</Typography>
                                        <Typography color='#949494'>{selectedMembership.price === 0.0 ? 'Free' : '$' + selectedMembership.price}</Typography>
                                    </Box>
                                </Box>
                            </Paper>
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: 'flex-end', mt: 2 }}>
                            {selectedMembership.price && selectedMembership.price > 0.0 ?
                                <RoundButton
                                    size="large"
                                    onClick={() => setShowPaymentModal(true)}
                                    variant="contained"
                                    sx={{ height: 'fit-content', mt: 2 }}
                                >
                                    Pay Now
                                </RoundButton>
                                :
                                <RoundButton
                                    size="large"
                                    onClick={updateMembership}
                                    variant="contained"
                                    sx={{ height: 'fit-content', mt: 2 }}
                                    loading={loading}
                                >
                                    Continue
                                </RoundButton>
                            }
                        </Box>
                    </Collapse>
                </Box>

            </Grid>
            <Footer></Footer>

            <ChargeModal
                show={showPaymentModal}
                setShow={setShowPaymentModal}
                amount={selectedMembership.price}
                onSuccess={onSuccess}
                payload={{type: 'membership', id: selectedMembership._id, uiStore}}
            />
        </>
    );
});

export default Membership;